import * as Sentry from "@sentry/react";
import { config } from "../../app.config";

Sentry.init({
  dsn: import.meta.env.PROD ? config.sentry.dsn : "",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllInputs: false,
      maskAllText: false,
      networkCaptureBodies: true,
      networkDetailAllowUrls: ["*"],
    }),
    Sentry.replayCanvasIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.httpClientIntegration(),
    Sentry.contextLinesIntegration(),
  ],
  environment: import.meta.env.PROD ? "production" : "development",

  /*
   * Caution: will fill up Sentry quota very fast
   * While in alpha we will have pretty ridicilous values on these.
   * These must be heavily tuned down once application is being used more
   */

  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions

  // Session Replay
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,

  // Profiling
  profilesSampleRate: 1.0,

  // Other
  attachStacktrace: true,
  sendDefaultPii: false,
});
